
import { Vue, Component, Prop } from 'vue-property-decorator';

import RequestActions from './RequestActions.vue';
import RequestData from './RequestData.vue';
import RequestPlaceholder from './RequestPlaceholder.vue';
import NumberInput from '@/components/input/NumberInput.vue';

import { formatDateForInput } from '@/utils/date';

import { ConsultationRequest, ConsultationStatus } from '@/types/consultations';

@Component({
    components: {
        RequestActions,
        RequestData,
        RequestPlaceholder,
        NumberInput,
    }
})
export default class RequestItemLayout extends Vue {
    @Prop() request!: ConsultationRequest;
    @Prop({ default: false }) hasActions!: boolean;

    get humanTime() {
        if (this.request.time) {
            const [date, time] = this.request.time.start.split(' ');
            const readableDate = formatDateForInput(date);

            return `${time} ${readableDate}`;
        }

        return '';
    }

    get confirmDisabled() {
        return !this.request.doctor || !this.request.time;
    }
    
    updateStatus(status: ConsultationStatus) {
        this.$emit('update:status', status);
    }

}
